import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'store/types';
import { ThunkAction } from 'redux-thunk';
import RestServiceClient from 'store/rest/RestServiceClient';
/* eslint-disable */

// ✅ Define el tipo correcto para la respuesta del servidor
interface AuthResponse {
  email: any;
  message: string;
  role: string;
  tenantId: number;
}

interface AuthState {
  token: string | null;
  email: any | null;
  message: string | null;
  role: string | null;
  tenantId: number | null;
}

const initialState: AuthState = {
  token: null,
  message: null,
  email: null,
  role: null,
  tenantId: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<AuthResponse>) => {
      state.token = action.payload.message;
      state.message = action.payload.message;
      state.email = action.payload.email;
      state.role = action.payload.role;
      state.tenantId = Number(action.payload.tenantId);
      localStorage.setItem("token", action.payload.message);
      localStorage.setItem("email", action.payload.email);
      localStorage.setItem("role", action.payload.role);
      localStorage.setItem("tenantId", String(action.payload.tenantId));
    },
    logout: (state) => {
      state.message = null;
      state.email = null;
      state.token = null;
      state.role = null;
      state.tenantId = null;
      localStorage.removeItem("token");
      localStorage.removeItem("email");
      localStorage.removeItem("role");
      localStorage.removeItem("tenantId");
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;

export const login =
  (email: string, password: string): ThunkAction<Promise<boolean>, AppState, RestServiceClient, any> =>
  async (dispatch, getState, client) => {
    try {
      const response = await client.restClient.post<AuthResponse>("user/login", { email, password });
      dispatch(authSlice.actions.loginSuccess(response.data));
      await new Promise((resolve) => setTimeout(resolve, 300));
      if (!response.data.message || response.data.message === "null" || response.data.message === "undefined") {
        throw new Error("Token inválido recibido");
      }else{
        const userData = await client.get(`/tenant`);
        return true;
      }
    } catch (error) {
      console.error("Login failed:", error);
      return false;
    }
  };



export default authSlice.reducer;
